import { Button, Checkbox, Menu } from 'antd';
import type { ItemType } from 'antd/es/menu/hooks/useItems';
import type { FilterDropdownProps } from 'antd/es/table/interface';

import type { PackageFilterGroup, PackageFilterOption } from '../utils';

const MENU_PREFIX_CLS = 'ant-dropdown-menu';
const BUTTONS_CLASS_NAME = 'ant-table-filter-dropdown-btns';

const toggleKey = (keys: string[], key: string) =>
  keys.includes(key) ? keys.filter((k) => k !== key) : [...keys, key];

type PackageFilterDropdownProps = FilterDropdownProps & {
  groups: PackageFilterGroup[];
};

export const PackageFilterDropdown = ({
  groups,
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
}: PackageFilterDropdownProps) => {
  const checkedKeys = selectedKeys.map(String);

  const toMenuItem = ({ text, value }: PackageFilterOption): ItemType => ({
    key: value,
    label: (
      <>
        <Checkbox checked={checkedKeys.includes(value)} />
        <span>{text}</span>
      </>
    ),
  });

  const items: ItemType[] =
    groups.length > 1
      ? groups.map((group) => ({
          key: group.title,
          type: 'group',
          label: group.title,
          children: group.options.map(toMenuItem),
        }))
      : groups.flatMap((group) => group.options.map(toMenuItem));

  const handleReset = () => {
    clearFilters?.();
    confirm();
  };

  return (
    <>
      <Menu
        selectable={false}
        prefixCls={MENU_PREFIX_CLS}
        onClick={({ key }) => setSelectedKeys(toggleKey(checkedKeys, key))}
        items={items}
      />
      <div className={BUTTONS_CLASS_NAME}>
        <Button
          type="link"
          size="small"
          disabled={checkedKeys.length === 0}
          onClick={handleReset}
        >
          Reset
        </Button>
        <Button type="primary" size="small" onClick={() => confirm()}>
          OK
        </Button>
      </div>
    </>
  );
};
